export function applyShiftHoursRules(form) {
    if (!form.shiftAutoClose && !form.shiftAutoOpen) {
        form.shiftHours = null;
    }

    if (!form.shiftHours || Object.keys(form.shiftHours).length === 0) {
        form.shiftAutoClose = false;
        form.shiftAutoOpen = false;
    }

    return form;
}
